import { eventListener, TOPICS } from "@origin-digital/event-dispatcher";
import { NATIVE_QUERY_STRING_IDENTIFIER } from "@origin-digital/native-features";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { logger } from "@origin-digital/reporting-client";

import { nativeEmulatorPlatformHandler } from "./handlers/nativeEmulatorPlatformHandler";
import { nativePlatformHandler } from "./handlers/nativePlatformHandler";
import { webPlatformHandler } from "./handlers/webPlatformHandler";
import { SubscribeTopics } from "./mesh.types";

//Listener list should match type SubscribeTopics
const listenerNames: SubscribeTopics["topic"][] = [
  TOPICS.AUTH_USER,
  TOPICS.NAV_TO,
  TOPICS.NAV_TO_URL,
  TOPICS.NAV_BACK,
  TOPICS.NAV_CLOSE,
  TOPICS.NAV_COMPLETE,
  TOPICS.NAV_HREF,
  TOPICS.NAV_HREF_TITLE,
  TOPICS.HTTP_REQ_ERROR,
  TOPICS.OPEN_RESOURCE,
  TOPICS.FETCH_ACCESS_TOKEN,
  TOPICS.FETCH_PLATFORM_PARAMETERS,
  TOPICS.FETCH_NATIVE_FEATURES,
  TOPICS.TOAST_SHOW,
  TOPICS.MODAL_OPEN,
  TOPICS.MODAL_CLOSE,
  TOPICS.CHAT_MESSENGER_SHOW,
  TOPICS.CHAT_MESSENGER_HIDE,
  TOPICS.OPEN_CHAT_CLIENT,
  TOPICS.RESTORE_CHAT_CLIENT,
  TOPICS.ASYNC_MESSENGER_OPEN,
  TOPICS.ASYNC_MESSENGER_CLOSE,
  TOPICS.SURVEY_INIT,
  TOPICS.SURVEY_CLOSE,
  TOPICS.LINK_EV_ACCOUNT,
  TOPICS.DEVICE_WALLET_SUPPORTED,
  TOPICS.DEVICE_WALLET_OPEN,
  TOPICS.LOGOUT,
  TOPICS.FETCH_THEME,
  TOPICS.HIDE_NATIVE_TAB_BAR,
  TOPICS.STEP_UP_AUTH,
];

let unSubListeners: () => void;

const chatClientTopics = new Set<SubscribeTopics["topic"]>([
  TOPICS.OPEN_CHAT_CLIENT,
  TOPICS.RESTORE_CHAT_CLIENT,
]);

export const withChatClientSdkGate = (
  listener: (event: SubscribeTopics) => any,
  enabled: boolean
): ((event: SubscribeTopics) => any) => {
  return (event: SubscribeTopics): any => {
    if (!enabled && chatClientTopics.has(event.topic)) {
      logger.warn("[od/mesh] chat client SDK is not enabled", {
        topic: event.topic,
      });
      return Promise.resolve();
    }

    return listener(event);
  };
};

export interface IInitHandler {
  isNative: boolean;
  environment: EnvironmentNames;
  enableChatClientSdk?: boolean;
  /**
   * current query string as a parameters object
   */
  parameters: Record<string, string>;
}

export function initHandler({
  isNative,
  environment,
  enableChatClientSdk = false,
  parameters,
}: IInitHandler): void {
  const gePlatformHandler = () => {
    if (parameters[NATIVE_QUERY_STRING_IDENTIFIER] != null)
      return nativeEmulatorPlatformHandler({
        environment,
      });

    if (isNative) return nativePlatformHandler({ environment });

    return webPlatformHandler({ environment });
  };
  const platformHandler = gePlatformHandler();
  unSubListeners = eventListener.addListeners(
    listenerNames,
    withChatClientSdkGate(platformHandler.listener, enableChatClientSdk)
  );
}

// export for testing
export function __unSubListeners(): void {
  if (unSubListeners) {
    unSubListeners();
  }
}
